// Value: Alpha 3-code
// https://www.iban.com/country-codes
export default [
  {
    label: 'USA',
    value: 'USA',
  },
  {
    label: 'Canada',
    value: 'CAN',
  },
]
